// Renk tanımları
export const COLORS = {
    NAVY: "#221C5D",
    ORANGE: "#E56A22",
    SUCCESS: "#71C30B",
    DANGER: "#E07A7A",
    WARNING: "#FFC107",
    INFO: "#17A2B8",
    LIGHT: "#F8F9FA",
    DARK: "#333333"
};

// Tahsilat tipi: ödemenin hangi akıştan geldiği (backend PaymentSource enum'u).
// Sıra filtre seçeneklerinde de kullanılır.
// Tahsilat tipi yalnız online tahsilatlarda anlamlı. Cari detayında hareket olarak
// elle girilen tahsilatlarda backend boş döner ve listede tire basılır.
// Tahsilat tipi: ödeme hangi akıştan geldi. Kural backend'de (PaymentSourceClassifier).
// Renkler header butonlarıyla aynı: panelden alınanlar lacivert, linkten gelenler turuncu.
export const PAYMENT_SOURCES = [
    { key: "COMPANY_PANEL", label: "Anlık Tahsilat", chipClass: "chip-navy-solid" },
    { key: "ACCOUNT_PANEL", label: "Cari/Bayi", chipClass: "chip-navy-solid" },
    { key: "INVOICE", label: "Fatura ile Tahsilat", chipClass: "chip-navy-solid" },
    { key: "PAYMENT_LINK", label: "Link ile Ödeme", chipClass: "chip-orange-solid" },
    { key: "FIXED_LINK", label: "Sabit Link", chipClass: "chip-orange-solid" },
    { key: "MANUAL", label: "Elden Tahsilat", chipClass: "chip-gray" },
];

// Ödeme yöntemi filtresinin grupları; değer backend'e receiptType olarak gider (virgülle çoklu).
export const PAYMENT_METHOD_GROUPS = [
    { key: "CREDIT_CARD", label: "Kart" },
    { key: "CASH", label: "Nakit" },
    { key: "BANK_TRANSFER", label: "Havale/EFT" },
    { key: "CHECK,PROMISSORY_NOTE", label: "Çek/Senet" },
];

// Payment durumları ve renkleri
export const PAYMENT_STATUS = {
    SUCCESS: { key: 'SUCCESS', label: 'Başarılı', color: 'success' },
    COMPLETED: { key: 'COMPLETED', label: 'Tamamlandı', color: 'success' },
    PENDING: { key: 'PENDING', label: 'Beklemede', color: 'warning' },
    WAITING: { key: 'WAITING', label: 'Bekliyor', color: 'warning' },
    FAILED: { key: 'FAILED', label: 'Başarısız', color: 'danger' },
    CANCELLED: { key: 'CANCELLED', label: 'İptal Edildi', color: 'danger' },
    REFUNDED: { key: 'REFUNDED', label: 'İade Edildi', color: 'secondary' },
    PARTIALLY_REFUNDED: { key: 'PARTIALLY_REFUNDED', label: 'Kısmi İade', color: 'info' }
};

// Hesap türleri
export const ACCOUNT_TYPES = {
    SOLE_PROPRIETORSHIP: 'Şahıs Şirketi',
    JOINT_STOCK_COMPANY: 'Anonim Şirket',
    LIMITED_COMPANY: 'Limited Şirket',
    COOPERATIVE: 'Kooperatif',
    GENERAL_PARTNERSHIP: 'Kolektif Şirket',
    COMMANDITE_COMPANY: 'Komandit Şirket',
    INDIVIDUAL: 'Bireysel',
    CORPORATE: 'Kurumsal'
};

export const DEFAULT_PAGE_SIZES = [10, 25, 50];